import React from 'react'
import { useTypedSelector } from 'src/redux/root-reducer'
import { MaturedWrapper } from './maturedStyle'
import { GeneralSpinner } from 'src/components/Global/Spinner/Spinner'
import { NoInvestmentSvg } from 'src/assets/index'
import { InvestmentCard } from 'src/components/Global/Cards/Cards'

const MaturedInvestment = () => {
  const investData = useTypedSelector((state) => state.invest.user.investments)
  const investLoading = useTypedSelector((state) => state.invest.loading)

  const maturedInvestmentData = investData?.filter((item: any) => {
    return item?.mature === true
  })

  console.log(maturedInvestmentData)

  return (
    <MaturedWrapper>
      {maturedInvestmentData?.length === 0 && (
        <div className="no_investment_img">
          <img src={NoInvestmentSvg} alt="" />
          <p>No investment. Invest now!</p>
        </div>
      )}

      {maturedInvestmentData?.length !== 0 && <InvestmentCard></InvestmentCard>}
    </MaturedWrapper>
  )
}

export default MaturedInvestment
